import z from "zod";

const aedAmount = (label: string) =>
  z
    .number({ invalid_type_error: `${label} is required` })
    .min(0, `${label} must be 0 or higher`);

export const APP_SETTINGS_FORM_SCHEMA = z.object({
  minAppVersion: z
    .string()
    .trim()
    .regex(/^\d+\.\d+\.\d+$/, "Use the MAJOR.MINOR.PATCH format, e.g. 5.3.0"),
  localBrandsEnabled: z.boolean(),
  generalNotice: z.string().trim(),
  generalNoticeAr: z.string().trim(),
  minimumOrderAmount: aedAmount("Minimum order amount"),
  deliveryFee: aedAmount("Delivery fee"),
  deliveryCutOff: aedAmount("Free delivery cut-off"),
  scheduledMinimumOrderAmount: aedAmount("Minimum order amount"),
  scheduledDeliveryFee: aedAmount("Delivery fee"),
  scheduledDeliveryCutOff: aedAmount("Free delivery cut-off"),
  codExtraFee: aedAmount("COD fee"),
  sameDayDeliveryEnabled: z.boolean(),
  sameDayCutoff: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Pick a cut-off time"),
  deliveryOffDays: z
    .array(z.number().int().min(0).max(6))
    .max(6, "Keep at least one delivery day"),
});

export type AppSettingsFormData = z.infer<typeof APP_SETTINGS_FORM_SCHEMA>;
